import { Grid } from 'antd';
import type { ReactNode } from 'react';
import { orgCardShadow, orgFormPanelStyle } from './organisationsUi';

export function OrgFormPanel({ children }: { children: ReactNode }) {
  const screens = Grid.useBreakpoint();
  const isCompact = !screens.md;

  return (
    <section
      style={{
        ...orgFormPanelStyle,
        padding: isCompact ? '22px 18px' : orgFormPanelStyle.padding,
        boxShadow: orgCardShadow,
      }}
    >
      {children}
    </section>
  );
}
